import React from 'react';

const ProviderSkeleton = () => (
  <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-slate-100 animate-pulse">
    <div className="w-full h-48 bg-slate-200" />
    <div className="p-5">
      <div className="flex justify-between mb-2">
        <div>
          <div className="h-5 w-40 bg-slate-200 rounded mb-2" />
          <div className="h-4 w-32 bg-slate-200 rounded" />
        </div>
        <div className="text-right">
          <div className="h-5 w-16 bg-slate-200 rounded mb-1" />
          <div className="h-3 w-12 bg-slate-200 rounded" />
        </div>
      </div>
      <div className="h-4 w-48 bg-slate-200 rounded mb-3" />
      <div className="flex gap-4 mb-4">
        <div className="h-4 w-20 bg-slate-200 rounded" />
        <div className="h-4 w-16 bg-slate-200 rounded" />
        <div className="h-4 w-14 bg-slate-200 rounded" />
      </div>
      <div className="flex gap-1 mb-4">
        <div className="h-6 w-20 bg-slate-200 rounded" />
        <div className="h-6 w-24 bg-slate-200 rounded" />
        <div className="h-6 w-16 bg-slate-200 rounded" />
      </div>
      <div className="h-12 w-full bg-slate-200 rounded-xl" />
    </div>
  </div>
);

export default ProviderSkeleton;
